export default __webpack_public_path__ + "static/media/polaroid.c85d9eb7.gif";